// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3Rpzw","amount":"Amount_amount__2txnT","tip":"Amount_tip__32IAL","tipHeader":"Amount_tipHeader__YRZjW","tipsWrap":"Amount_tipsWrap__2QDyz"};